import { twJoin } from "tailwind-merge";

/** Decorative background shared by the full Ask Nobi page and its chat drawer. */
export function AskNobiAmbientBackground({ variant = "page" }: { variant?: "page" | "drawer" }): React.ReactNode {
  return (
    <span
      aria-hidden="true"
      className={twJoin(
        "pointer-events-none absolute inset-0",
        variant === "page" ? "nobi-page-background" : "nobi-drawer-background",
      )}
    />
  );
}
